<div class='photo-grid-container'>
  <div class='client-pics' *ngIf="!!photos && photos.length > 0">
    <img *ngFor='let photo of photos' [src]="photo.thumb_url" (click)="doClick(photo.token)" />
  </div>
  <h4 *ngIf='!photos || photos.length == 0'>{{emptyMssg}}</h4>
</div>
